import "./index.scss";
const MissionImage = ({ src }: { src: any }) => {
  return <img src={src} alt="mission" className="mission-image" />;
};
export default MissionImage;
